module.exports = __webpack_public_path__ + "img/zhan.fed79d11.jpeg";